module.exports = __webpack_public_path__ + "static/plan-4374ac7acc715f7985afdc6e573ec73b.svg";